import {OrderLine} from '../transport/apiServiceResponse';

import {toAUD} from './functions';

export const makeByLineText = (item: OrderLine) =>
  item && item.size
    ? item.size.quantity > 1
      ? `${item.size.quantity} x ${item.size.size}${item.size.unit}`
      : `${item.size.size}${item.size.unit}`
    : 'N/A';

/**
 * "was $x.xx" — product RRP story when a usable non_member tier exists (same rule
 * as resolvePricing Was), else top-level normal > sell.
 */
export const makeOriginalPriceText = (product: OrderLine) => {
  const extras = Array.isArray(product.extra_prices) ? product.extra_prices : [];
  const nonMember = extras.find(p => p.price_level_external_reference === 'non_member_price');
  const nonMemberSell =
    nonMember && typeof nonMember.sell_price === 'number' && Number.isFinite(nonMember.sell_price)
      ? nonMember.sell_price
      : null;
  const nonMemberNormal =
    nonMember &&
    typeof nonMember.normal_price === 'number' &&
    Number.isFinite(nonMember.normal_price)
      ? nonMember.normal_price
      : null;

  if (nonMemberSell !== null && nonMemberNormal !== null) {
    return nonMemberNormal > nonMemberSell ? `was ${toAUD(nonMemberNormal)}` : null;
  }

  return product.normal_price_cents > product.sell_price_cents
    ? `was ${toAUD(product.normal_price_cents)}`
    : null;
};
